<script lang="ts">
import Markdown from '@/V2/chat/components/messages/Markdown.vue';

export default {
  name: 'ChatMessageAssistant',
  components: { Markdown },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <div class="chat-message-assistant">
    <Markdown :content="message.content" />
  </div>
</template>

<style lang="scss" scoped>
.chat-message-assistant {
  max-width: 85%;
  margin-right: auto;
  text-align: left;
  color: var(--text-neutral-bold);
}
</style>
